/** Visual status set used by the QR overlay across photo-scanning and qr-review.
 *  Mirrors the backend `qr_status` enum on `batch_page_records`. */
export type QrOverlayStatus =
  | 'success'
  | 'mismatched'
  | 'unverified'
  | 'failed';

interface OverlayStyle {
  /** Tailwind class for the SVG polygon stroke colour. */
  stroke: string;
  /** Tailwind class for the SVG polygon fill colour. */
  fill: string;
  /** Tailwind classes for the corner chip background + border. */
  badge: string;
  /** i18n key inside the `qrOverlay` namespace for the chip's label. */
  badgeText: 'matched' | 'mismatched' | 'unverified' | 'failed';
}

// Picked to mirror the right-panel problem-card palette so the operator's
// visual mapping stays consistent across the app.
export const QR_OVERLAY_STYLES: Record<QrOverlayStatus, OverlayStyle> = {
  success: {
    stroke: 'stroke-emerald-500',
    fill: 'fill-emerald-500/10',
    badge: 'bg-emerald-600 text-white border-emerald-700',
    badgeText: 'matched'
  },
  mismatched: {
    stroke: 'stroke-red-500',
    fill: 'fill-red-500/15',
    badge: 'bg-red-600 text-white border-red-700',
    badgeText: 'mismatched'
  },
  unverified: {
    stroke: 'stroke-amber-500',
    fill: 'fill-amber-500/15',
    badge: 'bg-amber-500 text-white border-amber-600',
    badgeText: 'unverified'
  },
  failed: {
    stroke: 'stroke-red-500',
    fill: 'fill-red-500/15',
    badge: 'bg-red-600 text-white border-red-700',
    badgeText: 'failed'
  }
};
